import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.0625 1.875C13.032 1.875 16.25 5.09295 16.25 9.0625C16.25 10.8222 15.6176 12.4342 14.5678 13.6836L17.9415 17.0581C18.1856 17.3022 18.1856 17.6979 17.9415 17.942C17.7162 18.1673 17.3617 18.1847 17.1165 17.994L17.0576 17.942L13.6836 14.5678C12.4342 15.6176 10.8222 16.25 9.0625 16.25C5.09295 16.25 1.875 13.032 1.875 9.0625C1.875 5.09295 5.09295 1.875 9.0625 1.875ZM9.0625 3.125C5.78331 3.125 3.125 5.78331 3.125 9.0625C3.125 12.3417 5.78331 15 9.0625 15C12.3417 15 15 12.3417 15 9.0625C15 5.78331 12.3417 3.125 9.0625 3.125Z",
		fill: "#878A8F"
	})
});
export default SvgSearch;
